module.exports = __webpack_public_path__ + "img/logo.b2d4c2ac.svg";